//#region src/reasons/buildCsatMetadata.ts
var e = 2048, t = "csat_reasons", n = (n, r) => {
	if (r.length === 0) return n;
	let i = {
		...n ?? {},
		[t]: r.join(",")
	};
	return JSON.stringify(i).length > e ? n : i;
};
//#endregion
export { t as CSAT_REASONS_METADATA_KEY, n as buildCsatMetadata };
